import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  HStack,
  IconButton,
  FormControl,
  Flex,
  Stack,
  Breadcrumb,
  BreadcrumbItem,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import { ReactComponent as Back } from "assets/svg/back-arrow.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
// import { ReactComponent as NoDataIcon } from "assets/svg/noData.svg";
// import { ReactComponent as CardMask } from "assets/svg/card-mask.svg";

// import VerificationIcon from "assets/svg/verification.svg";
import Button from "components/Button/Button";
import Header from "components/dashHeader";
import Input from "components/Input/Input";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
// import Select from "components/Select/Select";
import Sidemenu from "components/sidemenu";
// import SupportBox from "components/support";
// import debounce from "lodash/debounce";
// import isEmpty from "lodash/isEmpty";
// import sortBy from "lodash/sortBy";
//css
import "pages/styles/dashboard/Account.css";
import { useGetAirtimePlansQuery } from "services/billsApi";
import { OptionLabel, RSelect } from "components/Select/RSelect";
import { useAddBankMutation } from "services/bankApi";

// import {
//   useAddBankMutation,
//   useDeleteBankMutation,
//   useGetBanksByCountryQuery,
//   useGetBanksDetailsQuery,
//   useResolveAccountMutation,
// } from "services/bankApi";
// import { useStore } from "store/index";
// import { del, get, post } from "util/axiosLib";
// import { logger } from "util/logger";

import getError from "util/getError";
import SuccessModal from "components/Modals/Success";

export default function MobileMoney(props) {
  const { logout, userData } = props;
  const history = useHistory();
  const currentPage = "Account";

  console.log(userData);

  const toast = useToast();
  const [state, setState] = useState({});
  const { onOpen, onClose, isOpen } = useDisclosure();

  const set = useCallback(
    (newState) => setState((state) => ({ ...state, ...newState })),
    [setState]
  );

  const { data: plans, isFetching: isPlansLoading } = useGetAirtimePlansQuery(
    userData?.country ? String(userData.country).toLowerCase() : null,
    {
      skip: !userData?.country,
    }
  );

  const [
    addBank,
    {
      data: addBankData,
      isLoading: isAddingBank,
      error: addBankError,
      isError: addBankHasError,
      isSuccess: isAddBankSuccess,
    },
  ] = useAddBankMutation();

  const save = (e) => {
    e.preventDefault();
    const reqData = {
      bankType: "mobilemoney",
      _bankType: "mobilemoney",
      bankAccountNumber: state?.phone,
      network: state?.operatorInfo?.name,
      country: String(userData?.country).toLowerCase(),
    };

    console.log(reqData);
    addBank({ ...reqData });
  };

  const handleSuccessModalClose = () => {
    onClose();
    history("/dashboard/account/mobilemoney");
  };

  const operators = useMemo(() => {
    if (plans) {
      return plans?.plans?.map((p) => ({
        label: <OptionLabel label={p.name} img={p.brandLogo} />,
        value: p.operatorId,
      }));
    }
  }, [plans]);

  const getOperatorInfo = useCallback(
    (operatorId) => {
      const operator = plans?.plans.find((p) => p.operatorId === operatorId);
      return {
        logo: operator.brandLogo,
        name: operator.name,
        currency: operator.currency,
        flag: operator.countryFlag,
        products: operator.products,
      };
    },
    [plans]
  );

  useEffect(() => {
    if (addBankHasError && addBankError) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(addBankError?.data?.error),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    if (isAddBankSuccess && addBankData) {
      onOpen();
    }
  }, [
    isAddBankSuccess,
    addBankHasError,
    addBankError,
    toast,
    addBankData,
    onOpen,
    // history,
  ]);

  // console.log(state);

  //   return <AccountBanks {...props} history={history} />;

  const isDisabled = useMemo(
    () =>
      !(state?.operatorInfo?.name || state?.phone) ||
      isPlansLoading ||
      isAddingBank,
    [state, isPlansLoading, isAddingBank]
  );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={logout} />
      <Header />

      <Box as="section">
        <div className="account-container">
          <Flex className="flex">
            <Box flex=".8" borderRight="1px solid #D9DBE9" position="sticky">
              <Container maxW="calc(100% - 2em)" ml="10px">
                <Stack mb="48px">
                  <Heading>Account</Heading>
                  <Breadcrumb
                    className="animate__animated animate__fadeInDown"
                    separator={
                      <ArrowForwardIosRoundedIcon
                        style={{ fontSize: ".8em", color: "#6E7191" }}
                      />
                    }
                  >
                    <BreadcrumbItem>
                      <BreadcrumbLink to="/dashboard/account">
                        Account
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage to="">
                        Mobile Money
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Stack>

                <AccountSidebar
                  current="mobilemoney"
                  userData={userData}
                  logout={logout}
                />
              </Container>
            </Box>

            <Box flex="1" mt={{ sm: "30px", lg: "60px" }}>
              <Container
                // maxW={{
                //   sm: "calc(100% - 13em)",
                //   lg: "calc(100% - 13em)",
                //   xl: "calc(100% - 20em)",
                // }}
                maxW="lg"
                // ml={{ lg: "60px" }}
                m="0 auto"
                className="container"
                // bg="white"
              >
                <HStack w="100%" justifyContent="space-between">
                  <HStack>
                    <IconButton
                      bg="transparent"
                      boxSize="30px"
                      minW="30px"
                      minH="30px"
                      aria-label="add mobile money"
                      _hover={{
                        // bg: "#03A4383f",
                        shadow: "0 0 0 3px var(--focusColor)",
                      }}
                      _focus={{
                        // bg: "#03A4383f",
                        shadow: "0 0 0 3px var(--focusColor)",
                      }}
                      icon={<Box boxSize="24px" as={Back} color="black" />}
                      onClick={() =>
                        history.push("/dashboard/account/mobileMoney")
                      }
                    />
                    <Heading fontSize="24px">Add Mobile Money</Heading>
                  </HStack>
                </HStack>

                <Stack as="form" mt="30px" onSubmit={save}>
                  {/* <FormControl>
                    <Input minH="56px" label="Mobile Money name" />
                  </FormControl> */}
                  <FormControl mb="30px !important">
                    <Box
                      as="label"
                      d="inline-block"
                      fontSize=".85em"
                      fontWeight="400"
                      mb="8px"
                      color="#4E4B66"
                    >
                      Network Type
                    </Box>
                    <RSelect
                      isSearchable={false}
                      isDisabled={!userData?.country}
                      isLoading={isPlansLoading}
                      value={state?.selectValue ?? null}
                      onChange={(option) =>
                        set({
                          operatorId: option.value,
                          operatorInfo: getOperatorInfo(option.value),
                          selectValue: option,
                          topupType: null,
                        })
                      }
                      options={operators}
                    />
                  </FormControl>
                  <FormControl>
                    <Input
                      minH="56px"
                      label="Phone number"
                      value={state?.phone ?? ""}
                      onChange={(e) => set({ phone: e.target.value })}
                    />
                  </FormControl>

                  <Button
                    mt="30px !important"
                    minH="64px"
                    disabled={isDisabled}
                    type="submit"
                    isLoading={isAddingBank}
                  >
                    Save
                  </Button>
                </Stack>
              </Container>
            </Box>
          </Flex>
        </div>

        <SuccessModal
          isOpen={isOpen}
          onClose={handleSuccessModalClose}
          title="Success"
          message="Mobile money was successfully added"
        />
      </Box>
    </Box>
  );
}
